/* eslint-disable */

import {
    CATEGORIZED_COOKIES,
    COOKIE_DEFAULT_CATEGORY
} from 'tradera-constants/cookies';
import GdprSettings from 'tradera-utils/gdpr-settings';
import logger from 'packages/logger';

class CookieUtil {
    constructor(document = window.document) {
        this.document = document;
    }

    /**
     * @returns GdprSettings
     */
    _getGdprSettings() {
        if (typeof this.gdpr === 'undefined') {
            this.gdpr = GdprSettings;
        }
        return this.gdpr;
    }

    segment(name, value) {
        return value ? '; ' + name + '=' + value : '';
    }

    convertToExpiresStr(expires) {
        let expiresStr = '';

        switch (expires.constructor) {
            case Number:
                expiresStr =
                    expires === Infinity
                        ? '; expires=Fri, 31 Dec 9999 23:59:59 GMT'
                        : '; max-age=' + expires * 24 * 60 * 60;
                break;
            case String:
                expiresStr = '; expires=' + expires;
                break;
            case Date:
                expiresStr = '; expires=' + expires.toUTCString();
                break;
        }

        return expiresStr;
    }

    createCookie(cookieKey, cookieValue, expires, path, domain, secure) {
        let expiresStr = '';

        if (
            !cookieKey ||
            /^(?:expires|max\-age|path|domain|secure)$/i.test(cookieKey)
        ) {
            return false;
        }

        // check gdpr for cookie category
        let category = CATEGORIZED_COOKIES[cookieKey];
        if (typeof category === 'undefined') {
            logger(`No category set for cookie ${cookieKey}`);
            category = COOKIE_DEFAULT_CATEGORY;
        }
        if (!this._getGdprSettings().isCategoryEnabled(category)) {
            // console.info(
            //     `Cookie category not enabled: ${cookieKey}, category: ${category}`
            // );
            return false;
        }

        // if expired set prepare date string
        if (expires) {
            expiresStr = this.convertToExpiresStr(expires);
        }

        // console.info(`setting cookie: ${cookieKey} = ${cookieValue}`);
        this.document.cookie =
            encodeURIComponent(cookieKey) +
            '=' +
            encodeURIComponent(cookieValue) +
            expiresStr +
            this.segment('domain', domain) +
            this.segment('path', path || '/') +
            this.segment('secure', secure);

        return true;
    }

    readCookie(key) {
        return (
            decodeURIComponent(
                this.document.cookie.replace(
                    new RegExp(
                        '(?:(?:^|.*;)\\s*' +
                            encodeURIComponent(key).replace(
                                /[\-\.\+\*]/g,
                                '\\$&'
                            ) +
                            '\\s*\\=\\s*([^;]*).*$)|^.*$'
                    ),
                    '$1'
                )
            ) || null
        );
    }

    hasCookie(key) {
        return new RegExp(
            '(?:^|;\\s*)' +
                encodeURIComponent(key).replace(/[\-\.\+\*]/g, '\\$&') +
                '\\s*\\='
        ).test(this.document.cookie);
    }

    eraseCookie(key, path, domain) {
        if (!key || !this.readCookie(key)) {
            return false;
        }

        this.document.cookie =
            encodeURIComponent(key) +
            '=; expires=Thu, 01 Jan 1970 00:00:01 GMT' +
            this.segment('domain', domain) +
            this.segment('path', path || '/');

        return true;
    }
}

export default new CookieUtil();
export { CookieUtil };
